<template>
    <v-card color="transparent" v-if="loading" class="w-[450px] !rounded-3xl relative">
        <v-skeleton-loader type="image,article" height="100%" class=" skeleton">
        </v-skeleton-loader>
    </v-card>


    <v-card v-else-if="video" elevation="5" id="preview" class="w-[450px] !rounded-3xl " dark>
        <video autoplay loop muted :src="video" class="!object-cover !max-h-full !rounded-3xl" height="100%" width="100%">
        </video>
        <div class="bg-gradient-to-t from-black to-transparent h-full w-full absolute top-0 !rounded-3xl"></div>
    </v-card>
    <v-card v-else elevation="5" id="preview"
        class="w-[450px] !rounded-3xl !relative after:w-12 text-center after:text-white after:font-Handel after:h-6 after:bg-black after:content-['AD'] after:content-center after:rounded-bl-lg after:rounded-tr-3xl after:absolute after:top-0 after:right-0 after:z-50"
        dark>
        <v-img height="100%" width="100%" :lazy-src="adverisment[randomNumber].image"
        :src="adverisment[randomNumber].image"
        >
        <a :href="adverisment[randomNumber].link" target="_blank" class="w-full absolute h-full top-0 left-0" >
        </a>
            </v-img>
    </v-card>
</template>
<script>
import { Icon } from '@iconify/vue2';


export default {
    data() {
        return {
            randomNumber: 0,
            adverisment: [
                {
                    image: 'https://images.pexels.com/photos/7500606/pexels-photo-7500606.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
                    link: 'https://www.nike.com/'
                },
                {
                    image: 'https://images.pexels.com/photos/2048548/pexels-photo-2048548.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
                    link: 'https://www.nike.com/'
                },
                {
                    image: 'https://images.pexels.com/photos/14906627/pexels-photo-14906627.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
                    link: 'https://briskin.cafe24.com/shop3'
                },
                {
                    image: 'https://images.pexels.com/photos/15205136/pexels-photo-15205136.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
                    link: 'https://us.coca-cola.com/'
                },
            ],

            video: false,
            loading: false,
        };
    },
    computed: {
    },
    methods: {
        randomImage() {
           this.randomNumber =  Math.floor(Math.random() * this.adverisment.length);
        }
    },
    mounted() {
        this.randomImage();
    },
    components: { Icon }
};
</script>
<style scoped>
.skeleton:deep(.v-skeleton-loader__image) {
    width: 100% !important;
    height: 100% !important;
    z-index: 1;
}

.skeleton:deep(.v-skeleton-loader__article) {
    position: absolute;
    z-index: 5;
    width: 100% !important;
    bottom: 40px;
    border-radius: 0px !important;
    background: transparent !important;
}
</style>
  